import { Text, Modal, ButtonGroup, PrimaryButton } from "@certn/cascadia";
import {
  DialogContent,
  DialogFooter,
  DialogHeader,
  Dialog,
  List,
  ListItem,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function ReviewDecisionLearnMoreModal() {
  const { t } = useTranslation();

  return (
    <Modal testID="review-decision-modal">
      <Dialog>
        {({ close }) => (
          <>
            <DialogHeader onClose={close}>
              {t("Understanding your results")}
            </DialogHeader>
            <DialogContent>
              {t(
                "Your Nationally Coordinated Criminal History Check (NCCHC) may not return the results you expected. This may be because:"
              )}
              <List type="unordered">
                <ListItem>
                  <Text style="form/list">
                    The police information released does not belong to you{" "}
                  </Text>
                </ListItem>
                <ListItem>
                  <Text style="form/list">
                    Part of the police information does not belong to the you{" "}
                  </Text>
                </ListItem>
                <ListItem>
                  <Text style="form/list">
                    The police information belongs to you, but the details are
                    inaccurate{" "}
                  </Text>
                </ListItem>
                <ListItem>
                  <Text style="form/list">
                    The police information belongs to you, but should not have
                    been released{" "}
                  </Text>
                </ListItem>
                <ListItem>
                  <Text style="form/list">
                    Police information belonging to you has not been released{" "}
                  </Text>
                </ListItem>
              </List>
            </DialogContent>
            <DialogFooter>
              <ButtonGroup>
                <PrimaryButton size="medium" onPress={close}>
                  {t("Close")}
                </PrimaryButton>
              </ButtonGroup>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}
